'use client';
import { useState, useEffect, useRef } from 'react';
import RedemptionList from '@/components/index/RedemptionList'; // 商品列表
import Pagination from '@/components/layout/Pagination'; // 頁碼
import exchangeClient from '@/common/apiClient/exchangeClient';

const LIMIT = 20;

interface Props {
    initItems: any[];
    totalPage: number;
    initPageIndex?: number;
}

const RedemptionClientWrapper = ({ initItems = [], totalPage = 0, initPageIndex = 0 }: Props) => {
    // 商品
    const [items, setItems] = useState<any[]>(initItems);
    const [pageIndex, setPageIndex] = useState<number>(initPageIndex);
    const isFirstRender = useRef(true);

    // 換頁時重新取得商品列表（初始頁已由 server 端帶出，不需重打）
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        const fetchItems = async () => {
            const { records = [] } = await exchangeClient.findItems({
                pageIndex,
                limit: LIMIT,
            });
            setItems(records);
        };

        fetchItems();
    }, [pageIndex]);

    return (
        <>
            {/* 商品列表 */}
            <RedemptionList items={items} />

            {/* 頁碼列 */}
            {totalPage > 1 && (
                <Pagination
                    pageIndex={pageIndex}
                    setPageIndex={setPageIndex}
                    pageSize={totalPage}
                />
            )}
        </>
    );
};

export default RedemptionClientWrapper;
